import { type RouteObject, createBrowserRouter, redirect } from 'react-router-dom';
import { supportedLngs } from '@/i18n/config';
import { getDetectedLanguage } from '@/i18n/detected';

import Error404 from '@/components/error/404';
import Error500 from '@/components/error/500';
import Home from '@/pages/Home';
import BookletPage from '@/pages/booklet';
import SponsorsPage from '@/pages/sponsors';

import Explore from '@/pages/explore';
import HamzaCairokeeMarwanConcertPage from '@/pages/hamza-cairokee-marwan-concert';

import EventDetailAndExperiencesPage from '@/pages/events';
import AppLayout from '../App';

import { exploreRoutes } from './explore';
import { termsRoutes } from './terms';
import { wbkRoutes } from './wbk';
import { zonesRoutes } from './zone';

export const router = createBrowserRouter([
  {
    path: '/:lang',
    element: <AppLayout />,
    loader: async ({ request }) => {
      const path = new URL(request.url).pathname;
      const firstSegment = (path?.split('/')?.[1] || '') as Language;
      const isValidLang = supportedLngs.includes(firstSegment);

      if (!isValidLang) {
        const resolved = await getDetectedLanguage();
        const search = new URL(request.url)?.searchParams?.toString();
        const safeSearch = search ? `?${search}` : '';
        return redirect(`/${resolved}${path}${safeSearch}`);
      }
      return null;
    },
    children: (
      [
        {
          path: '',
          element: <Home />,
          errorElement: <Error500 />,
        },
        {
          path: 'booklets',
          errorElement: <Error404 />,
          element: <BookletPage />,
        },
        {
          path: 'laylat-alomr',
          errorElement: <Error404 />,
          element: <SponsorsPage />,
        },
        {
          path: 'events/:slug',
          element: <EventDetailAndExperiencesPage pagetype='events' />,
        },
        {
          path: 'explore',
          element: <Explore />,
        },
        {
          path: 'hamza-cairokee-marwan-concert-rs25-tickets',
          element: <HamzaCairokeeMarwanConcertPage />,
        },
        {
          path: '*',
          element: <Error404 />,
        },
      ] as RouteObject[]
    ).concat(zonesRoutes, termsRoutes, exploreRoutes),
  },
  {
    path: '/:lang',
    errorElement: <Error404 />,
    children: wbkRoutes,
  },
  {
    path: '/',
    loader: async ({ request }) => {
      const resolved = await getDetectedLanguage();
      const search = new URL(request.url)?.searchParams?.toString();
      const safeSearch = search ? `?${search}` : '';
      return redirect(`/${resolved}${safeSearch}`);
    },
  },
]);
